import React, { useEffect, useState } from "react";
import { createServicesHeidi, AddlogocoverHeidi } from "../../Services/appDashboardApi";
import { UploadSVG } from "../../assets/icons/upload";
import { useTranslation } from "react-i18next";
import Select from "react-tailwindcss-select";
import { validateURL } from "../util/linkValidation";
import { getServiceById, getServicesHeidi, updateService } from "../../Services/terminal";
import { base64ToFile } from "../terminalDashboard/TerminalForm";
import { getValidationErrors } from '../../helpers'
import { fetchImageAsBlob } from "../../Services/mediaUtils";
import ImageCrop from "../imageCrop";
async function dataToFormData(data, isEdit) {
    const formData = new FormData();
    const {
        logoImage,
        coverImage,
        subServices,
        name: serviceName,
        cityIds,
        logoPath,
        coverPath,
        logoImageTemp,      // discard
        coverImageTemp,     // discard
        ...rest
    } = data;

    // Discard logoImageTemp and coverImageTemp from subServices
    const cleanedSubServices = subServices?.map(
        ({ logoImage, coverImage, logoImageTemp, coverImageTemp, ...subRest }) => subRest
    );

    const cleanData = {
        ...rest,
        name: serviceName,
        cityIds: isEdit ? cityIds[0] : cityIds,
        subServices: cleanedSubServices,
    };
    
    formData.append("data", JSON.stringify(cleanData));
    const normalizeServiceName = serviceName.normalize('NFKD').replace(/[\u0300-\u036f]/g, "");
    if (coverImage && serviceName) {
        if (typeof coverImage === "string" && !coverImage.startsWith("https")) {
            const file = base64ToFile(coverImage);
            formData.append(`${normalizeServiceName}_cover`, file);
        } else if (coverPath) {
            const blobLogo = await fetchImageAsBlob(base64ToFile(coverImage));
            formData.append(`${normalizeServiceName}_cover`, blobLogo);
        }
    }

    for (const sub of subServices) {
        const subName = sub?.name;
        const normalizeSubName = subName.normalize('NFKD').replace(/[\u0300-\u036f]/g, "");
        if (sub?.coverImage && subName) {
            if (typeof sub?.coverImage === "string" && !sub?.coverImage?.startsWith("https")) {
                const file = base64ToFile(sub?.coverImage);
                formData.append(`${normalizeSubName}_cover`, file);
            } else if (sub?.coverPath) {
                const blobLogo = await fetchImageAsBlob(base64ToFile(sub?.coverImage));
                formData.append(`${normalizeSubName}_cover`, blobLogo);
            }
        }
    };
    return formData;
}


const AddService = ({ cityId, close, handleSucess, selectedService, isEdit }) => {
    const { t } = useTranslation();
    const [newService, setNewService] = useState({
        name: "",
        description: "",
        serviceTypeId: null,
        cityIds: [cityId],
        metadata: {
            path: "",
            isValidPath: true
        },
        coverImageTemp: '',
        logoImageTemp: '',
        coverImage: '',
        logoImage: '',
        subServices: [],
        logoPath: '',
        coverPath: '',
    });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [services, setServices] = useState([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState({
        name: null,
        serviceTypeId: null,
        images: null,
        subServiceErrors: [], // ✅ error for each subservice
    });
    const [service, setService] = useState();

    const handleFileChange = (e, changeState, field = "") => {
        const file = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
            setError(prev => ({ ...prev, [field]: t("upload_file_type") }));
            changeState({ image: null });
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            changeState(reader.result);
            setError(prev => ({ ...prev, [field]: null }));
        };
        reader.readAsDataURL(file);
    };


    const handleAddService = async () => {
        const errors = getValidationErrors(newService, t);
        if (Object.keys(errors).length > 0) {
            setError(errors);
            return;
        }
        setLoader(true);
        if (isEdit) {
            try {
                const sendData = await dataToFormData(newService, true)
                updateService(newService.id, sendData).then(() => {
                    setSuccessMessage(t("addServiceSuccess"))
                    handleSucess(t("addServiceSuccess"))
                    close()
                }).catch(e => {
                    setErrorMessage(e?.response?.data?.message)
                    setTimeout(() => {
                        setErrorMessage('');
                        setSuccessMessage('');
                        setLoader(false);
                    }, 2000)
                })
            } catch (e) {
                setErrorMessage(e?.response?.data?.message || t("Failed"))
                setTimeout(() => {
                    setErrorMessage('');
                    setSuccessMessage('');
                    setLoader(false);
                }, 2000)
            }
        } else {
            try {
                const sendData = await dataToFormData(newService, false)
                createServicesHeidi(sendData).then((res) => {
                    setSuccessMessage(t("addServiceSuccess"))
                    handleSucess(t("addServiceSuccess"))
                    setService(null);
                    close()
                }).catch(e => {
                    setErrorMessage(e?.response?.data?.message)
                    setTimeout(() => {
                        setErrorMessage('');
                        setSuccessMessage('');
                        setLoader(false);
                    }, 2000)
                })
            } catch (e) {
                setErrorMessage(e?.response?.data?.message || t("Failed"))
                setTimeout(() => {
                    setErrorMessage('');
                    setSuccessMessage('');
                    setLoader(false);
                }, 2000)
            }
        }
    };
    const deleteSubservices = (index) => {
        const updateServices = [...newService.subServices]
        updateServices.splice(index, 1);
        setNewService({ ...newService, subServices: updateServices });
    }
    const addSubServices = () => {
        setNewService({
            ...newService,
            subServices: [
                ...newService.subServices,
                {
                    name: "",
                    description: "",
                    metadata: {
                        path: "",
                        isValidPath: true
                    },
                    logoImageTemp: '',
                    coverImageTemp: '',
                    coverImage: '',
                    logoImage: '',
                    logoPath: '',
                    coverPath: ''
                }
            ]
        });
    };

    useEffect(() => {
        getServicesHeidi().then((ser) => setServices(ser.data.data.rows?.map((cities) => ({ value: cities.id, label: cities.name }))));
    }, [])

    useEffect(() => {
        if (selectedService?.id) {
            getServiceById(selectedService?.id).then((res) => {
                setNewService({
                    name: res.data?.data?.name,
                    title: res.data?.data?.name,
                    description: res.data?.data?.description,
                    cityIds: [cityId],
                    metadata: { ...res.data?.data?.metadata, isValidPath: true },
                    serviceTypeId: res.data?.data?.serviceTypeId,
                    id: res.data?.data?.id,
                    coverImageTemp: res.data?.data?.coverImage,
                    logoImageTemp: res.data?.data?.logoImage,
                    coverImage: res.data?.data?.coverImage,
                    logoImage: res.data?.data?.logoImage,
                    logoPath: res.data?.data?.logoPath,
                    coverPath: res.data?.data?.coverPath,
                    subServices: res.data?.data?.children?.map(child => ({
                        ...child,
                        coverImageTemp: child?.coverImage,
                        logoImageTemp: child?.logoImage,
                        metadata: { ...child.metadata, isValidPath: true }
                    })) ?? []
                })
            }
            )
            setService(services.find((ser) => ser.value === selectedService?.serviceType?.id ? { label: ser.name, value: ser.id } : null))
        }
    }, [selectedService, services])

    return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl p-4 grid grid-cols-1 gap-1 w-[50%] lg:ml-40 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold">{isEdit ? 'Edit' : 'Add'} {t("serviceLabel")}</h2>
                <button onClick={close} className="text-gray-400 hover:text-gray-600 text-xl leading-none">✕</button>
            </div>
            <Select
                primaryColor="indigo"
                placeholder={t("selectServiceLabel")}
                options={services ?? []}
                value={service}
                onChange={(val) => {
                    setNewService((prev) => ({
                        ...prev,
                        serviceTypeId: val?.value || null
                    }));
                    setService(val);
                    setError((prev) => ({ ...prev, serviceTypeId: null }));
                }}
            />
            {error?.serviceTypeId && <p className="text-red-500 text-sm mt-1">{error?.serviceTypeId}</p>}

            <input
                type="text"
                placeholder={t("titleLabel")}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                value={newService.name}
                onChange={(e) => { setNewService({ ...newService, name: e.target.value }); setError((prev) => ({ ...prev, name: null })); }}
            />
            {error?.name && <p className="text-red-500 text-sm mt-1">{error?.name}</p>}

            <textarea
                placeholder={t("descriptionLabel")}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                value={newService.description}
                onChange={(e) => setNewService({ ...newService, description: e.target.value })}
            />

            <input
                type="url"
                placeholder={t("webLink")}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                value={newService.metadata?.path}
                onChange={(e) => {
                    if (validateURL(e.target.value)) {
                        setNewService({ ...newService, metadata: { path: e.target.value, isValidPath: true } });
                    } else {
                        setNewService({ ...newService, metadata: { path: e.target.value, isValidPath: false } });
                    }
                }}
            />
            {!newService?.metadata?.isValidPath && (
                <p className="text-red-500 text-sm mt-1">{t("validurl")}</p>
            )}
           <div className="flex w-full gap-4">
                {/* Logo section removed */}

                {/* Cover Image */}
                {newService.coverImageTemp ? (
                    <div className="w-full flex flex-col items-center self-start">
                        <div className="relative h-64 w-full">
                            <ImageCrop
                                imgSrc={newService.coverImageTemp}
                                onCropComplete={(cropImage) => {
                                    setNewService({ ...newService, coverImage: cropImage })
                                }}
                            />
                            <button
                                className="bg-black text-white shadow-lg rounded-lg w-full py-2 px-4 mt-2"
                                onClick={() =>
                                    setNewService({
                                        ...newService,
                                        coverImageTemp: null,
                                        coverImage: null
                                    })
                                }
                            >
                                {t("removeFile")}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="text-center w-full">
                        <UploadSVG />
                        <p className="mt-1 text-sm text-gray-900">
                            {t("dragAndDropImage")}
                        </p>
                        <div className="relative mt-8">
                            <label className="bg-black text-white shadow-lg rounded-lg w-full py-2 px-4 cursor-pointer">
                                <span>{t("uploadCover")}</span>
                                <input
                                    id="file-upload"
                                    type="file"
                                    accept="image/*"
                                    className="sr-only"
                                    onChange={(e) =>
                                        handleFileChange(
                                            e,
                                            (e) =>
                                                setNewService({
                                                    ...newService,
                                                    coverImageTemp: e,
                                                    coverImage: e
                                                }),
                                            "images"
                                        )
                                    }
                                />
                            </label>
                        </div>
                    </div>
                )}
            </div>
            {error?.images && <p className="text-red-500 text-sm mt-1">{error?.images}</p>}

            <div className="mt-6">
                <h4 className="font-medium mb-2">{t("subServicesLabel")}</h4>
                {newService?.subServices?.map((subSer, i) => (
                    <div key={i} className="mb-4 p-4 border rounded bg-gray-50">
                        <div className="w-full flex justify-end">
                            <button onClick={() => deleteSubservices(i)} className="text-gray-400 hover:text-gray-600">✕</button>
                        </div>
                        <input
                            type="text"
                            placeholder={t("titleLabel")}
                            className="w-full mb-2 px-4 py-2 border border-gray-300 rounded"
                            value={subSer.name}
                            onChange={(e) => {
                                const updated = [...newService.subServices];
                                updated[i].name = e.target.value;
                                setNewService({ ...newService, subServices: updated });
                                setError((prev) => {
                                    const subErrors = [...(prev.subServiceErrors || [])];
                                    if (!subErrors[i]) subErrors[i] = {};
                                    subErrors[i].name = null;
                                    return { ...prev, subServiceErrors: subErrors };
                                });
                            }}
                        />
                        {error?.subServiceErrors?.[i]?.name && (
                            <p className="text-red-500 text-sm mt-1">{error.subServiceErrors[i].name}</p>
                        )}
                        <textarea
                            placeholder={t("descriptionLabel")}
                            className="w-full mb-2 px-4 py-2 border border-gray-300 rounded"
                            value={subSer.description}
                            onChange={(e) => {
                                const updated = [...newService.subServices];
                                updated[i].description = e.target.value;
                                setNewService({ ...newService, subServices: updated });
                            }}
                        />
                        <input
                            type="url"
                            placeholder={t("webLink")}
                            className="w-full mb-2 px-4 py-2 border border-gray-300 rounded"
                            value={subSer?.metadata?.path || ""}
                            onChange={(e) => {
                                const updated = [...newService.subServices];
                                if (!updated[i].metadata) {
                                    updated[i].metadata = { path: "", isValidPath: true };
                                }
                                updated[i].metadata.path = e.target.value;
                                updated[i].metadata.isValidPath = validateURL(e.target.value);
                                setNewService({ ...newService, subServices: updated });
                            }}
                        />
                        {!subSer?.metadata?.isValidPath && (
                            <p className="text-red-500 text-sm mt-1">{t("validurl")}</p>
                        )}
                        <div className="flex items-center mt-4 h-[20rem] gap-2">
                            {/* Logo section removed */}

                            {/* Cover Image */}
                            {subSer?.coverImageTemp ? (
                                <div className="w-full flex flex-col items-center self-start">
                                    <div className="h-64 w-full">
                                        <ImageCrop
                                            imgSrc={subSer.coverImageTemp}
                                            onCropComplete={(cropImage) => {
                                                const updated = [...newService.subServices];
                                                updated[i].coverImage = cropImage;
                                                setNewService({ ...newService, subServices: updated });
                                            }}
                                        />
                                        <button
                                            className="bg-black text-white shadow-lg rounded-lg w-full py-2 px-4 mt-2"
                                            onClick={() => {
                                                const updated = [...newService.subServices];
                                                updated[i].coverImage = null;
                                                updated[i].coverImageTemp = null;
                                                setNewService({ ...newService, subServices: updated });
                                            }}
                                        >
                                            {t("removeFile")}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center w-full">
                                    <UploadSVG />
                                    <p className="mt-1 text-sm text-gray-900">
                                        {t("dragAndDropImage")}
                                    </p>
                                    <div className="relative mt-8">
                                        <label className="bg-black text-white shadow-lg rounded-lg w-full py-2 px-4 cursor-pointer">
                                            <span>{t("uploadCover")}</span>
                                            <input
                                                id="file-upload"
                                                type="file"
                                                accept="image/*"
                                                className="sr-only"
                                                onChange={(e) =>
                                                    handleFileChange(e, (ev) => {
                                                        const updated = [...newService.subServices];
                                                        updated[i].coverImageTemp = ev;
                                                        updated[i].coverImage = ev;
                                                        setNewService({
                                                            ...newService,
                                                            subServices: updated,
                                                        });
                                                    })
                                                }
                                            />
                                        </label>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
                <button
                    onClick={addSubServices}
                    className="text-sm text-blue-600 hover:underline mt-1"
                >
                    {t("addSubServicesLabel")}
                </button>
            </div>
            {successMessage && <p className="text-green-600 text-bold text-center mt-2">{successMessage}</p>}
            {errorMessage && <p className="text-red-600 text-bold text-center mt-2">{errorMessage}</p>}
            <div className="flex flex-row gap-4 justify-center">
                <button
                    onClick={close}
                    className="px-4 py-2 border border-gray-300 rounded text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                    {t("cancel")}
                </button>
                <button
                    onClick={handleAddService}
                    disabled={loader}
                    className="w-fit px-4 py-2 bg-blue-600 rounded text-white rounded hover:bg-indigo-600"
                >
                    {loader ? (
                        <div className="w-5 h-5 rounded-full border-2 border-white border-t-transparent animate-spin"></div>
                    ) : (
                        (isEdit ? t("saveChanges") : t("add")+ t("serviceLabel"))
                    )}
                </button>
            </div>
        </div>
    </div>;
}

export default AddService;
